import type { TFunction } from 'i18next'

export const getPriceDistanceTypeOptions = (t: TFunction) => [
	{
		value: 'add',
		label: t('anchoring_management.strategy.tab.price_distance.additive.label'),
		description: t(
			'anchoring_management.strategy.tab.price_distance.additive.description'
		),
	},
	{
		value: 'mul',
		label: t(
			'anchoring_management.strategy.tab.price_distance.multiplicative.label'
		),
		description: t(
			'anchoring_management.strategy.tab.price_distance.multiplicative.description'
		),
	},
]
